import React, { createContext, useContext } from "react";
import { HookedReactable } from "@reactables/react";
import { RxCoverageApplication } from "./RxCoverageApplication";

type HookedRxCoverageApplication = HookedReactable<
  typeof RxCoverageApplication
>;

const RxCoverageApplicationContext = createContext<
  HookedRxCoverageApplication | undefined
>(undefined);

type RxCoverageApplicationProviderProps = {
  value: HookedRxCoverageApplication;
  children: React.ReactNode;
};

export const RxCoverageApplicationProvider: React.FC<
  RxCoverageApplicationProviderProps
> = ({ value, children }) => {
  return (
    <RxCoverageApplicationContext.Provider value={value}>
      {children}
    </RxCoverageApplicationContext.Provider>
  );
};
export function useRxCoverageApplication(): HookedRxCoverageApplication {
  const context = useContext(RxCoverageApplicationContext);

  if (!context) {
    throw new Error(
      "useRxCoverageApplication must be used within an RxCoverageApplicationProvider",
    );
  }
  return context;
}
